import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class CatalogTeaser extends BaseComponent {
    properties() {
        return {
            dataId: '',
            dataTitle: '',
            dataTooltipText: '3 catalogs have been selected already',
        };
    }

    events() {
        return {
            document: {
                'add-catalog': (e) => {
                    if (`${e.detail.id}` === `${this.dataId}`) {
                        const input = this.element.querySelector('input');
                        if (input) input.checked = true;
                    }
                },
                'remove-catalog': (e) => {
                    if (`${e.detail.id}` === `${this.dataId}`) {
                        const input = this.element.querySelector('input');
                        if (input) input.checked = false;
                    }
                },
                'catalog-cart-update': (e) => {
                    const input = this.element.querySelector('input');

                    if (!input) return;

                    if (e.detail.catalogs.length > 0 && !input.checked) {
                        for (const catalog of e.detail.catalogs) {
                            if (`${catalog.id}` === `${this.dataId}`) {
                                input.checked = true;
                            }
                        }
                    }

                    if (e.detail.catalogs.length < 3) {
                        input.disabled = false;
                        $(input).tooltip('dispose');
                    }

                    if (e.detail.catalogs.length === 3 && !input.checked) {
                        input.disabled = true;
                        this.addTooltip();
                    }
                },
            },
            input: {
                change: (e) => {
                    if (e.target.checked) {
                        this.dispatch('add-catalog', { id: this.dataId, title: this.dataTitle });
                    } else {
                        this.dispatch('remove-catalog', { id: this.dataId, title: this.dataTitle });
                    }
                },
            },
            '[trigger-tooltip]': {
                mouseenter: () => {
                    const input = this.element.querySelector('input');
                    $(input).tooltip('show');
                },
                mouseleave: () => {
                    const input = this.element.querySelector('input');
                    $(input).tooltip('hide');
                },
            },
        };
    }

    addTooltip() {
        const input = this.element.querySelector('input');

        if (!input) return;

        $(input).tooltip({
            placement: 'top',
            trigger: 'focus manual',
            title: this.dataTooltipText,
            customClass: '',
            template:
                '<div class="tooltip is-dark" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        });
    }
}

defineComponent('catalog-teaser', CatalogTeaser);
